import React from "react";
import { useTranslation } from "react-i18next";
import EmailPreferences from "components/EmailPreferences/EmailPreferences";
import { PageHeader } from "components/ui";

/**
 * Account-level email preference centre page.
 *
 * A dedicated route rather than another row inside Account.tsx: that component
 * renders its sections through a map over a config array, and threading a
 * different kind of panel into it would have meant restructuring a screen this
 * work has no reason to touch.
 */
export const EmailPreferencesPage = () => {
  const { t } = useTranslation();
  return (
    <div className="zs-page zs-page-narrow">
      <PageHeader
        eyebrow={t("side.bar.Account")}
        title="Email preferences"
        subtitle="Decide which emails from Zamplia Surveys reach your inbox."
      />
      <EmailPreferences />
    </div>
  );
};

export default EmailPreferencesPage;
